var _defs, _path, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNtblogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 266.23 132.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M760,500.61c3.46-2.35,12.22-9.4,12.22-22.09,0-19.26-12.38-32.25-35.54-32.25H691.61V557.75H739c19.88,0,34.76-11.59,34.76-32.88C773.79,509.22,764.55,503.42,760,500.61ZM716.69,469.5h19.1c8.42,0,11,5.25,11,10.16s-2.62,10.16-11,10.16h-19.1Zm20.53,65H716.77V512.83h20.45c8.32,0,11.09,5.54,11.09,10.74S745.54,534.48,737.22,534.48Z",
    transform: "translate(-507.56 -446.27)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "58.53 57.18 21.71 0 0 0 0 111.48 26.28 111.48 26.28 54.3 63.11 111.48 84.8 111.48 84.8 0 58.53 0 58.53 57.18"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "93.32 23.26 121.95 23.26 134.62 11.53 134.62 32.73 122 44.93 122 132.73 134.7 121.02 134.7 111.47 147.17 111.47 147.17 23.26 175.87 23.26 175.87 0 93.32 0 93.32 23.26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNtblogo);
export default __webpack_public_path__ + "static/media/ntblogo.0a97e67cdf267d0a25e0d11d75857d4a.svg";
export { ForwardRef as ReactComponent };